import { fetchPaged } from "@/data/paging";
import { supabase } from "@/lib/supabase";
import type { ActivityTrackRow, TracksQueryOpts } from "@/types/map.types";
import { nextInstantIso } from "@/utils/date.utils";

const HARD_LIMIT = 2000;

export async function fetchMapActivities(
  q: TracksQueryOpts,
): Promise<ActivityTrackRow[]> {
  return fetchPaged<ActivityTrackRow>(
    () => {
      let req = supabase
        .from("activities")
        .select(
          "strava_activity_id,start_date,name,sport_type,summary_polyline",
        )
        .eq("has_polyline", true)
        .eq("is_deleted", false)
        .order("start_date", { ascending: false });

      if (q.public) {
        req = req.eq("visibility", "everyone");
      } else {
        req = req.eq("user_id", q.userId);
      }

      if (q.search?.trim()) {
        const term = q.search.trim().replace(/[%_]/g, "\\$&");
        req = req.or(`name.ilike.%${term}%,sport_type.ilike.%${term}%`);
      }

      switch (q.sports?.mode) {
        case "include": {
          if (q.sports.sports.length === 0) {
            req = req.eq("sport_type", "__none__");
          } else {
            req = req.in("sport_type", q.sports.sports);
          }
          break;
        }
        case "exclude": {
          if (q.sports.sports.length > 0) {
            req = req.not("sport_type", "in", `(${q.sports.sports.join(",")})`);
          }
          break;
        }
        case "all":
        default:
          break;
      }

      if (q.from) req = req.gte("start_date", q.from);
      if (q.to) req = req.lt("start_date", nextInstantIso(q.to));

      return req;
    },
    {
      limit: q.limit,
      hardLimit: HARD_LIMIT,
    },
  );
}
